import { createSelector } from '@reduxjs/toolkit';

import type { LiveStreamEntries, LiveStreamState } from './types';
import type { ReduxState } from 'app/redux/types';

import type { RecordOfLiveStreamEntry } from './records';

// ---

export const selectLiveStreamState = (state: ReduxState): LiveStreamState => {
  return state.liveStream;
};

export const selectLiveStreamLoading = (state: ReduxState): LiveStreamState['loading'] => {
  return selectLiveStreamState(state).loading;
};

export const selectLiveStreamEntries = (state: ReduxState): LiveStreamEntries => {
  return selectLiveStreamState(state)?.entries;
};

export const selectLiveStreamEntriesFirst = createSelector(
  selectLiveStreamEntries,
  (entries) => {
    return entries.sortBy((entry) => entry.sportId)
      .first<RecordOfLiveStreamEntry>();
  },
);

export const selectLiveStreamPreferences = (state: ReduxState): LiveStreamState['preferences'] => {
  return selectLiveStreamState(state)?.preferences;
};

export const selectLiveStreamClosed = (state: ReduxState): LiveStreamState['preferences']['closed'] => {
  return selectLiveStreamPreferences(state)?.closed;
};

export const selectStreamId = (state: ReduxState): LiveStreamState['preferences']['streamId'] => {
  return selectLiveStreamPreferences(state).streamId;
};

export const selectedStream = createSelector(
  selectLiveStreamEntries,
  (state: ReduxState) => selectStreamId(state),
  (entries, selectedMatchId) => {
    if (entries.size === 0 || !selectedMatchId) {
      return null;
    }

    return entries.get(selectedMatchId);
  },
);

export const selectHasLiveStream = (state: ReduxState, matchId: number): boolean => {
  return selectLiveStreamEntries(state)?.has(matchId);
};
